import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { OnboardingApiService } from './apis/onboarding-api';
import { OnboardingApiServiceImpl } from './apis/impls/onboarding-api';
import { OnboardingService } from './services/onboarding-service';
import { OnboardingServiceImpl } from './services/impls/onboarding-service';

export const onboardingContainer = new ContainerModule(bind => {
    bind(OnboardingApiService).to(OnboardingApiServiceImpl);
    bind(OnboardingService).to(OnboardingServiceImpl);
});
